import { apiRequest } from './client'

/** One per-date half-day slot, matching the apply flow's `halfDays`. */
export interface HalfDayEntryInput {
  date: string // ISO YYYY-MM-DD
  slot: 'AM' | 'PM'
}

/** Payload for HR encoding an out-of-system leave on an employee's behalf. */
export interface EncodeOutOfSystemLeaveInput {
  employeeId: string
  type: string
  startDate: string // ISO YYYY-MM-DD
  endDate: string // ISO YYYY-MM-DD
  /** Per-date half-day slots. Each deducts 0.5 from the counted days. */
  halfDays?: HalfDayEntryInput[]
  /** HR marks this an emergency filing (feeds the pattern engine). */
  isEmergency?: boolean
  /** Employee-facing reason (stored as the leave's reason). */
  reason: string
  /** HR's justification for encoding out of system (the audit "why"). */
  outOfSystemReason: string
}

export interface EncodeOutOfSystemLeaveResult {
  leaveId: string
  status: string
  computedDays: string
  isOutOfSystem: boolean
}

/**
 * HR encodes a leave the submit-time gates hard-block (unpaid / blackout),
 * on an employee's behalf, landing it APPROVED. Backed by
 * POST /api/v1/hr/leaves/encode (HR-only, gated by
 * HR_OUT_OF_SYSTEM_ENCODE_ENABLED server-side). Attach the business-continuity
 * document afterwards via `uploadDocument(result.leaveId, file)`.
 */
export function encodeOutOfSystemLeave(
  input: EncodeOutOfSystemLeaveInput,
): Promise<EncodeOutOfSystemLeaveResult> {
  return apiRequest<EncodeOutOfSystemLeaveResult>('/api/v1/hr/leaves/encode', {
    method: 'POST',
    body: input,
  })
}
